module.exports = "/images/share-canvas-bg.png?915c3f089453d06e140f9b854a96eca6";


//////////////////
// WEBPACK FOOTER
// ./resources/images/share-canvas-bg.png
// module id = wTVi
// module chunks = 182